import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DataReference"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 9.75V3H17.25V4.5H15V6H17.25V9.75H15V11.25H21V9.75H18.75ZM6.375 4.5C7.82475 4.5 9 5.67525 9 7.125C9 8.57475 7.82475 9.75 6.375 9.75C4.92525 9.75 3.75 8.57475 3.75 7.125C3.75165 5.67594 4.92594 4.50165 6.375 4.5ZM6.375 3C4.09683 3 2.25 4.84683 2.25 7.125C2.25 9.40317 4.09683 11.25 6.375 11.25C8.65317 11.25 10.5 9.40317 10.5 7.125C10.5 6.03098 10.0654 4.98177 9.29182 4.20818C8.51823 3.4346 7.46902 3 6.375 3ZM17.625 15C19.0747 15 20.25 16.1753 20.25 17.625C20.25 19.0747 19.0747 20.25 17.625 20.25C16.1753 20.25 15 19.0747 15 17.625C15.0017 16.1759 16.1759 15.0017 17.625 15ZM17.625 13.5C15.3468 13.5 13.5 15.3468 13.5 17.625C13.5 19.9032 15.3468 21.75 17.625 21.75C19.9032 21.75 21.75 19.9032 21.75 17.625C21.75 15.3468 19.9032 13.5 17.625 13.5ZM4.5 14.25V15.75H7.1895L3 19.9395L4.0605 21L8.25 16.8105V19.5H9.75V14.25H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DataReference.vue"]]);
